export default __webpack_public_path__ + "static/media/travel1.54274929.png";